import React from 'react';
import styled from '@emotion/styled';
import { ArrowIcon, SortIcon, XIcon } from '../../components/icons';

const CardLayout = styled.button<{ selected: boolean }>`
  width: 100%;
  height: 66px;
  border: ${props => (props.selected ? '1px solid #f5f5f5' : '1px solid #444')};
  border-radius: 3px;
  background: ${props => (props.selected ? '#f5f5f5' : '#fff')};
  position: relative;
  cursor: pointer;
  margin-top: 6px;
  text-align: left;
  :hover {
    background-color: #f5f5f5;
    border: 1px solid #f5f5f5;
  }
  @media (min-width: 768px) {
    height: 88px;
    max-width: 216px;
    margin-right: 16px;
    margin-top: 0;
    padding: 0;
    :last-of-type {
      margin-right: 0;
    }
  }
  @media (min-width: 768px) {
    max-width: 205px;
  }
  @media (min-width: 1440px) {
    max-width: 238px;
  }
`;
const CardInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 8px;
  font-family: IBM Plex Sans;
  @media (min-width: 768px) {
    padding-left: 0;
  }
  @media (min-width: 1024px) {
    padding-left: 8px;
  }
`;
const CardAmount = styled.div`
  display: flex;
  align-items: center;
  @media (min-width: 768px) {
    /* flex-direction: column;
    align-items: start; */
    margin-left: 4px;
    width: 100%;
  }
  @media (min-width: 1024px) {
    /* flex-direction: row; */
    /* align-items: flex-end; */
  }
`;
const Number = styled.div`
  color: #444340;
  font-size: 48px;
  text-align: right;
  margin-left: 8px;
  @media (min-width: 768px) {
    font-size: 40px;
    text-align: left;
  }
`;
const StatusSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
  @media (min-width: 768px) {
    margin-left: 20px;
    margin-right: 70px;
  }
`;
const ArrowStyles = styled.div`
  position: absolute;
  bottom: 10px;
  right: 12px;
  @media (min-width: 768px) {
    bottom: 32px;
  }
`;
interface Props {
  number?: number;
  status: 'In Progress' | 'Partially Completed' | 'Completed' | 'Waiting on Client';
  onClick: () => void;
  selected: boolean;
}

const Card = (props: Props) => {
  return (
    <>
      <CardLayout onClick={() => props.onClick()} selected={props.selected}>
        <CardInfo>
          <CardAmount>
            <Number>{props.number}</Number>
            <StatusSection>
              <div style={{ fontSize: 11, color: '#93918F' }}>VIEW</div>
              <div style={{ fontSize: 14, fontWeight: 600 }}>{props.status}</div>
            </StatusSection>
          </CardAmount>
          <ArrowStyles>
            {props.selected ? <XIcon style={{ width: 18, height: 18 }} /> : <SortIcon />}
          </ArrowStyles>
        </CardInfo>
      </CardLayout>
    </>
  );
};

export default Card;
